module.exports = __webpack_public_path__ + "assets/images/video_example.jpg";